<template>
  <div class="l-edit-dialog-box" style="padding-top:0">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="top" v-loading="loading">
      <!-- <el-divider content-position="left">基础信息</el-divider> -->
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="12">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="form_data.username" autocomplete="off" placeholder="请输入用户名" :disabled="true"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="角色权限(根据上级来获取)" prop="role_id">
            <el-select v-model="form_data.role_id" placeholder="请选择当前权限" :disabled="role_list.length == 0" @change="role_changes">
              <el-option v-for="item in role_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="role_id_type != 1">
          <el-form-item label="归属公司" prop="corp_pid">
            <el-select v-model="form_data.corp_pid" placeholder="请选管理公司" @change="getdepartList">
              <el-option v-for="item in corp_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      
        <el-col :span="12" v-if="role_id_type != 1 && role_id_type != 2">
          <el-form-item label="归属部门" prop="depart_pid">
            <el-select v-model="form_data.depart_pid" placeholder="请选择部门" @change="getgroupList">
              <!-- role_id_type == 4 || role_id_type == 5 -->
              <el-option v-for="item in depart_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="12" v-if="role_id_type != 1 && role_id_type != 2 && role_id_type != 3">
          <el-form-item label="归属组名" prop="group_pid">
            <el-select v-model="form_data.group_pid" placeholder="请选择小组">
              <!-- :disabled=" this.code == 400 "  -->
              <!-- || role_id_type == 5 -->

              <el-option v-for="item in group_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "l-user-info-position",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    visible: {
      type: Boolean,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      loading: false, //页面是否加载中
      role_id_type: '',
      role_list: [],
      corp_list: [],
      depart_list: [],
      group_list: [],
      //表单数据
      form_data: {
        depart_pid: 0,
        group_pid: 0,
        corp_pid: 0,
        role_id: 0,
        username: "",
        id: "",
        role_id_type:""
      },
      //表单验证规则
      rules: {
        role_ids: [
          {
            required: true,
            message: "请选择职位",
            trigger: "change",
          },
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      },
    },
  },

  methods: {
    role_changes(data) {
      this.role_list.filter(i => {
        if (i.id === data) {
          this.role_id_type = i.type
        }
      })
    },
    // 点击部门获取小组 
    getgroupList() {
      this.$_invoke("adminUser_getBaseList", {
        id: this.form_data.depart_pid,
        type: 4
      })
        .then((ret) => {
          this.group_list = ret;
          this.form_data.group_pid = "";
        })
    },
    // 点击公司获取部门 
    getdepartList() {
      this.$_invoke("adminUser_getBaseList", {
        id: this.form_data.corp_pid,
        type: 3
      })
        .then((ret) => {
          this.form_data.group_pid = "";
          this.form_data.depart_pid = "";
          this.depart_list = ret;
          this.group_list = [];
        })
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },

    //获取数据
    getData() {
      this.loading = true;
      if (this.hasId) {
        this.$_invoke("userPosition_getPositionData", {
          id: this.$props.id,
        })
          .then((ret) => {
            console.log(ret)
            this.role_id_type = ret.role_type;
            this.role_list = ret.role_list;
            this.corp_list = ret.corp_list;
            this.depart_list = ret.depart_list;
            this.group_list = ret.group_list;
            this.form_data.role_id = ret.admin_info.role_id;
            this.form_data.username = ret.admin_info.username;
            this.form_data.corp_pid = parseInt(ret.admin_info.corp_pid);
            this.form_data.depart_pid =parseInt(ret.admin_info.depart_pid);
            this.form_data.group_pid = parseInt(ret.admin_info.group_pid);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (this.hasId) {
            //修改
            this.form_data.id = this.$props.id;
            this.form_data.role_id_type = this.role_id_type;
            this.$_invoke("userPosition_update", this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    },
  },
};
</script>